<form class="astral-dialog-form astral-stack-m" (ngSubmit)="submit()">
  <h2 class="astral-section-heading">{{ 'RENTAL_OBJECT.LETTING_FEATURES.SET_LETTING_FEATURES' | translate }}</h2>

  @if (addIncluded) {
    <section class="astral-section-surface astral-section-surface--compact astral-stack-s">
      <app-information-block
        mode="compact"
        [text]="'RENTAL_OBJECT.LETTING_FEATURES.SET_ADD_INCLUDED_DESCRIPTION'"
      ></app-information-block>

      <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
        @for (control of addIncluded.controls; track control) {
          <astral-select [control]="control" [itemsSource]="getFeatureSelectionItems(control)"></astral-select>
        }
      </astral-layout-group>
    </section>
  }

  @if (addNotIncluded) {
    <section class="astral-section-surface astral-section-surface--compact astral-stack-s">
      <app-information-block
        mode="compact"
        [text]="'RENTAL_OBJECT.LETTING_FEATURES.SET_ADD_NOT_INCLUDED_DESCRIPTION'"
      ></app-information-block>

      <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
        @for (control of addNotIncluded.controls; track control) {
          <astral-select [control]="control" [itemsSource]="getFeatureSelectionItems(control)"></astral-select>
        }
      </astral-layout-group>
    </section>
  }

  @if (deleteIncluded && deleteIncluded.length) {
    <section class="astral-section-surface astral-section-surface--compact astral-stack-s">
      <app-information-block
        mode="compact"
        [text]="'RENTAL_OBJECT.LETTING_FEATURES.SET_DELETE_INCLUDED_DESCRIPTION'"
      ></app-information-block>

      <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
        @for (included of deleteIncluded; track included.feature.id) {
          <astral-checkbox [control]="included.control"></astral-checkbox>
        }
      </astral-layout-group>
    </section>
  }

  @if (deleteNotIncluded && deleteNotIncluded.length) {
    <section class="astral-section-surface astral-section-surface--compact astral-stack-s">
      <app-information-block
        mode="compact"
        [text]="'RENTAL_OBJECT.LETTING_FEATURES.SET_DELETE_NOT_INCLUDED_DESCRIPTION'"
      ></app-information-block>

      <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1" [denseBooleanControls]="true">
        @for (notIncluded of deleteNotIncluded; track notIncluded.feature.id) {
          <astral-checkbox [control]="notIncluded.control"></astral-checkbox>
        }
      </astral-layout-group>
    </section>
  }

  <div class="astral-form-actions astral-form-actions--start">
    <astral-button variant="primary" type="submit" labelKey="OK_BTN"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
